// extracted by mini-css-extract-plugin
export default {"htmlContentRoot":"HtmlContent_htmlContentRoot__dntHy","small":"HtmlContent_small__noUqE"};